import ieqipCoreServiceApi from './ieqipCoreServiceApi';

// Create a new 503B operation
export const create503bOperation = (operationData) => {
    return ieqipCoreServiceApi.post('/api/inspections/inspection503boperations', operationData);
};

// Update a 503B operation (using POST like create, API determines create vs update based on ID presence)
export const update503bOperation = (operationData) => {
    return ieqipCoreServiceApi.post('/api/inspections/inspection503boperations', operationData);
};

// Delete a 503B operation by UID
export const delete503bOperation = (operationUid) => {
    return ieqipCoreServiceApi.delete(`/api/inspections/inspection503boperations/${operationUid}`);
};

// eslint-disable-next-line
export default {
    create503bOperation,
    update503bOperation,
    delete503bOperation
};
